import { ButtonType, DropdownButtonType, List, SingleSelectDropdown, TextLinkWidget } from '@tableau/widgets';
import React from 'react';

import { ButtonWithSpinner } from '~commonInfra/components/ButtonWithSpinner';
import { HelpService } from '~commonInfra/services/HelpService';

import { Messages } from '../../codegen/Localize';
import { getIntegrationSiteRoleItems } from './IntegrationSiteRoleListItems';
import { MultilineTextField } from './MultilineTextField';
import {
  AddIntegrationUsersDialogContainerStyle,
  DialogDescriptionStyle,
  DialogFieldLabelStyle,
  DialogSectionStyle
} from './styles/IntegrationUserDialogStyles';

export interface AddIntegrationUsersDialogProps {
  readonly dismiss: () => void;
  readonly close: (result: any) => void;
}

export interface AddIntegrationUsersDialogState {
  readonly userInput: string;
  readonly siteRole: string | undefined;
}

const INTEGRATION_USERS_HELP_TOKEN = 'integration-users';

export class AddIntegrationUsersDialog extends React.Component<AddIntegrationUsersDialogProps, AddIntegrationUsersDialogState> {

  public constructor(props: AddIntegrationUsersDialogProps) {
    super(props);
    this.state = { userInput: '', siteRole: undefined };
  }

  private readonly handleUsernamesChange = (userInput: string) => {
    this.setState({ userInput });
  };

  private readonly handleSiteRoleChange = (value: string) => {
    this.setState({ siteRole: value });
  };

  private readonly handleSubmit = () => {
    this.props.close({});
  };

  public render() {
    const isSubmitEnabled = this.state.userInput.trim().length > 0 && this.state.siteRole != null;
    const siteRoleButtonLabel = this.state.siteRole == null
      ? Messages.addIntegrationUsersSiteRolePlaceholder()
      : undefined;
    return (
      <div className='tb-dialog-integration-users' style={AddIntegrationUsersDialogContainerStyle}>
        <div className='tb-dialog-title'>{Messages.addIntegrationUsers()}</div>
        <div style={DialogDescriptionStyle}>
          {Messages.addIntegrationUsersDescription()}{' '}
          <TextLinkWidget
            href={HelpService.getServerHelpUrlByCategory(INTEGRATION_USERS_HELP_TOKEN)}
            target='_blank'
            testId='integration-users-learn-more'
          >
            {Messages.learnMore()}
          </TextLinkWidget>
        </div>
        <div style={DialogSectionStyle}>
          <div style={DialogFieldLabelStyle}>{Messages.addIntegrationUsersEnterUsernamesLabel()}</div>
          <div className='tb-dialog-body-control tb-multiline-text-holder'>
            <MultilineTextField
              handleChange={this.handleUsernamesChange}
              disabled={false}
              placeholder={Messages.addIntegrationUsersPlaceholder()}
              testId='integration-users-usernames'
            />
          </div>
        </div>
        <div style={DialogSectionStyle}>
          <div style={DialogFieldLabelStyle}>{Messages.siteRole_title()}</div>
          <SingleSelectDropdown
            list={<List items={getIntegrationSiteRoleItems()} />}
            value={this.state.siteRole}
            onChange={this.handleSiteRoleChange}
            type={DropdownButtonType.Outline}
            label=''
            aria-label={Messages.siteRole_title()}
            testId='integration-users-site-role-dropdown'
          >
            {siteRoleButtonLabel}
          </SingleSelectDropdown>
        </div>
        <div className='tb-dialog-actions'>
          <ButtonWithSpinner
            buttonType={ButtonType.Outline}
            onClick={this.props.dismiss}
            testId='confirm-action-dialog-cancel'
            children={Messages.cancel()}
          />
          <span className='tb-margin-left-wide'>
            <ButtonWithSpinner
              buttonType={ButtonType.Primary}
              onClick={this.handleSubmit}
              testId='confirm-action-dialog-submit'
              children={Messages.addIntegrationUsers()}
              disabled={!isSubmitEnabled}
            />
          </span>
        </div>
      </div>
    );
  }
}
